
import {useState} from "react";

const config = {
    iceServers: [
        {
            urls: "stun:openrelay.metered.ca:80",
        },
        {
            urls: "turn:openrelay.metered.ca:80",
            username: "openrelayproject",
            credential: "openrelayproject",
        },
        {
            urls: "turn:openrelay.metered.ca:443",
            username: "openrelayproject",
            credential: "openrelayproject",
        },
        {
            urls: "turn:openrelay.metered.ca:443?transport=tcp",
            username: "openrelayproject",
            credential: "openrelayproject",
        },
    ]
}

export default function useRTC(socket) {

    const [rtcPeer] = useState(new RTCPeerConnection(config));
    const [trackSenders, setTrackSenders] = useState([]);
    const [outStream] = useState(new MediaStream());

    const disconnect = () => {
        trackSenders.forEach(s => rtcPeer.removeTrack(s))
        //rtcPeer.close()
    }

    const addStream = stream => {
        console.log("ADD: Stream", stream);

        const t1 = stream.getAudioTracks()[0]
        const t2 = stream.getVideoTracks()[0]

        const sender1 = rtcPeer.addTrack(t1)
        const sender2 = rtcPeer.addTrack(t2)

        setTrackSenders([sender1, sender2])
        handshake()
    }

    function handshake(){

        console.log("START: Handshake");

        rtcPeer.ontrack = evt => {
            outStream.addTrack(evt.track)
        }
        
        rtcPeer.onicecandidate = evt => {
            const iceCandidate = evt.candidate;
            
            if (iceCandidate){
                const newIceCandidate = new RTCIceCandidate(iceCandidate);
                socket.emit('ice_candidate' , newIceCandidate)
            }
        }


        socket.on("new_connection", () => {
            console.log("NEW: Connection");

            // need to create offer after adding tracks so that the sdp
            // accurately describes what is being sent
            // whether that is audio, video, or a mix of both
            rtcPeer.createOffer().then(o => {
                rtcPeer.setLocalDescription(o)
    
                // send offer to other remotes
                // will get an answer back from remote
                console.log("SENT: Offer", o);
                socket.emit('rtc_link' , o)
            }).catch(e => console.log(e))
        });

        socket.on("rtc_link", desc => {
            if(desc.type === 'offer') {

                console.log("RECEIVED: Offer", desc);
                const d = new RTCSessionDescription(desc);

                rtcPeer.setRemoteDescription(d).then(() => {
                    rtcPeer.createAnswer().then(a => {
                        rtcPeer.setLocalDescription(a)
                        // respond with answer to caller
                        console.log("SENT: Answer", a);
                        socket.emit('rtc_link' , a)
                    }).catch(e => console.log(e))
                }).catch(e => console.log(e))

            } else if (desc.type === 'answer') {
                console.log("RECEIVED: Answer", desc);
                rtcPeer.setRemoteDescription(desc)
            } else {
                alert("Not a valid type:", desc.type)
            }
        })


        socket.on("ice_candidate", can => { 
            console.log("RECEIVED: Candidate", can);
            rtcPeer.addIceCandidate(can)
        })
    }

    // useEffect(() => {
    //     return () => {
    //         link.destroy()
    //         ice_can.destroy()
    //         new_con.destroy()
    //         rtcPeer.ontrack = null
    //         rtcPeer.onicecandidate = null
    //     }
    // })

    return {outStream, disconnect, addStream};
}